import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex" };
const _hoisted_2 = { class: "ml-3 py-4" };
const _hoisted_3 = { class: "text-sm font-medium text-white" };
const _hoisted_4 = { class: "mt-2 text-sm text-white" };
const _hoisted_5 = { class: "flex justify-end grow p-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon");
    const _component_InformationCircleIcon = _resolveComponent("InformationCircleIcon");
    const _component_ExclamationIcon = _resolveComponent("ExclamationIcon");
    const _component_XCircleIcon = _resolveComponent("XCircleIcon");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["invisible fixed top-8 inset-x-0 mx-auto max-w-md z-50 shadow-black border-b-4", { 'bg-green-600 border-green-700': _ctx.notification.type === 'success', 'bg-red-700 border-red-900': _ctx.notification.type === 'error', 'bg-amber-400 border-amber-600': _ctx.notification.type === 'info' }]),
        style: _normalizeStyle(_ctx.notification.visible ? 'visibility: visible' : null)
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
                class: _normalizeClass(["flex items-center p-2", { 'bg-green-500': _ctx.notification.type === 'success', 'bg-red-600': _ctx.notification.type === 'error', 'bg-amber-400': _ctx.notification.type === 'info' }])
            }, [
                (_ctx.notification.type === 'success')
                    ? (_openBlock(), _createBlock(_component_CheckCircleIcon, {
                        key: 0,
                        class: "h-12 w-12 text-green-400",
                        "aria-hidden": "true"
                    }))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.notification.type === 'info')
                    ? (_openBlock(), _createBlock(_component_InformationCircleIcon, {
                        key: 1,
                        class: "h-12 w-12 text-white",
                        "aria-hidden": "true"
                    }))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.notification.type === 'error')
                    ? (_openBlock(), _createBlock(_component_ExclamationIcon, {
                        key: 2,
                        class: "h-12 w-12 text-red-400",
                        "aria-hidden": "true"
                    }))
                    : _createCommentVNode("", true)
            ], 2),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.notification.title), 1),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.notification.message), 1)
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_XCircleIcon, {
                    class: "h-5 w-5 text-white justify-self-end cursor-pointer",
                    onClick: _ctx.handleClose
                }, null, 8, ["onClick"])
            ])
        ])
    ], 6));
}
